import { CellContext, createColumnHelper } from "@tanstack/react-table";
import React, { useState } from "react";
import { Col, Offcanvas } from "react-bootstrap";
import IConfirmacionMantenedor from "../../../../entities/helper/IConfirmacionMantenedor";
import IGerencia from "../../../../entities/IGerencia";
import ILogMantenedor from "../../../../entities/ILogMantenedor";
import IVicePresidencia from "../../../../entities/IVicePresidencia";
import { shortDate } from "../../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../../helpers/IFormHelper";
import { getAPI, postAPI } from "../../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../../../helpers/userHelper";
import {
  API_ADMIN_AREA_RESPONSABLE,
  API_ADMIN_MANTENEDOR_MEDIDA,
  API_ADMIN_PRODUCTO,
  API_ADMIN_PROVEEDOR,
  API_ADMIN_TIPO_PROCESO,
  ROW_COUNT,
  URL_SUPPORT,
} from "../../../../helpers/variableHelper";
import AdminLista from "../../AdminLista";
import RenderForm from "../../RenderForm";
import IMedida from "../../../../entities/IMedida";
import { ITipoProceso } from "../../../../entities/ITipoProceso";
import { IProducto } from "../../../../entities/IProducto";
import { IProveedor } from "../../../../entities/IProveedor";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import moment from "moment";
import ICurrentUser from "../../../../entities/helper/ICurrentUser";
import Select from "react-select";
import { IComboboxOption } from "../../../../entities/helper/IComboboxOption";
import CustomToast from "../../../../cross/CustomToast";
import { updateSelectedField } from "../UtilsMantenedor";
import { downloadFile } from "../../../../helpers/fileHelper";
import Loading from "../../../../cross/Loading";
import ProveedorService from "../../../../services/ProveedorService";
import RenderTitle from "../../../../controls/RenderTitle";
import RenderValue from "../../../../controls/RenderValue";
import RenderLink from "../../../../controls/RenderLink";
import { cParamsActiveOrderTitle } from "../../../../helpers/paramsHelper";
const MySwal = withReactContent(Swal);

interface IMantenedorMedidasProps {
  items?: Array<any>;
  cbVicePresidencia?: Array<IVicePresidencia>;
  cbTipoProceso?: Array<ITipoProceso>;
  cbProducto?: Array<IProducto>;
  cbProveedor?: Array<IProveedor>;
  cbGerencia?: Array<IGerencia>;
  itemsArrCambios?: Array<IConfirmacionMantenedor>;
  is_test?: boolean;
  loading?: boolean;
}

export default function MantenedorMedidas({
  is_test,
  loading,
  items,
  cbVicePresidencia,
  cbTipoProceso,
  cbProducto,
  cbProveedor,
  cbGerencia,
  itemsArrCambios,
}: IMantenedorMedidasProps) {
  let paramsActive = cParamsActiveOrderTitle;
  const userInfo = cognitoUserToken();

  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [comboVccMM, setComboVccMM] = useState<Array<IVicePresidencia>>(cbVicePresidencia || []);
  const [comboTPMM, setComboTPMM] = useState<Array<ITipoProceso>>(cbTipoProceso || []);
  const [comboPRDMM, setComboPRDMM] = useState<Array<IProducto>>(cbProducto || []);
  const [comboPRVMM, setComboPRVMM] = useState<Array<IProveedor>>(cbProveedor || []);

  const [isEditColum, setIsEditColumMM] = useState<boolean>(false);
  const [editColumnInfo, setEditColumnInfoMM] = useState<any>();
  const [listItemsMM, setListItemsMM] = useState<Array<any>>(items || []);
  const [isLoading, setIsLoading] = useState(loading ?? false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [showToast, setShowToastMM] = useState(false);
  const [hideTable, setHideTable] = useState(true);
  const [arrCambiosFormMM, setArrCambiosFormMM] = useState<Array<IConfirmacionMantenedor>>(itemsArrCambios || []);
  const [isOpenPopUpGuardarCambiosMM, setIsOpenPopUpGuardarCambiosMM] = useState<boolean>(false);

  const refTxtCorrMM = React.createRef<HTMLInputElement>();
  const [refcomboTPMM, setValComboTPMM] = useState<IComboboxOption | null>(null);
  const [refComboPRDMM, setValComboPRDMM] = useState<IComboboxOption | null>(null);
  const [refcomboPRVMM, setValComboPRVMM] = useState<IComboboxOption | null>(null);
  const [refComboUPMM, setValComboUPMM] = useState<IComboboxOption | null>(null);
  const [refComboVccMM, setValComboVccMM] = useState<IComboboxOption | null>(null);
  const [refComboGSGMM, setValComboGSGMM] = useState<IComboboxOption | null>(null);
  const [refComboCSCMM, setValComboCSCMM] = useState<IComboboxOption | null>(null);
  const [refComboEDMM, setValComboEDMM] = useState<IComboboxOption | null>(null);
  const [selectedField, setSelectedField] = useState({} as any);
  const [isSendingData, setIsSendingData] = useState(false);
  const refTxtMotivoMM = React.createRef<HTMLTextAreaElement>();
  const [pageSize, setPageSize] = useState(ROW_COUNT);

  const columnHelperMantMedidas = createColumnHelper<IMedida>();
  const columnHelperConfirmacionCambios = createColumnHelper<IConfirmacionMantenedor>();
  const changeField = (id: string, valor: any) => {
    let sf: any = updateSelectedField(id, valor);
    setSelectedField(sf);
  };

  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any, type?: number) => {
    return <RenderValue value={value} type={type} />;
  };

  const componentLink = (value: any) => {
    return <RenderLink value={value} />;
  };

  const componentDesactivar = (value: any) => {
    let desactivar = value.row.original.ACTIVO ? "Desactivar" : "Activar";
    return (
      <button
        className="btnIcono"
        title={desactivar}
        onClick={() => {
          console.log("value.row.original", value.row.original);
          MySwal.fire({
            html: (
              <div>
                <h3>
                  ¿Desea {desactivar.toLowerCase()} el registro {value.row.original.TITULO}?
                </h3>
              </div>
            ),
            text: "",
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              MySwal.fire({
                html: (
                  <div>
                    <h4>Ingrese un Motivo:</h4>
                  </div>
                ),
                input: "textarea",
                inputAttributes: {
                  autocapitalize: "off",
                },
                showCancelButton: true,
                confirmButtonText: `<i class="bi bi-eye"></i>${desactivar}`,
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                preConfirm: async (txtMotivo) => {
                  preconfirm(
                    txtMotivo,
                    value.row.original.ID,
                    value.row.original.ACTIVO,
                    value.row.original.TITULO,
                    value.row.original.ID_PLANIFICACION
                  );
                },
                allowOutsideClick: () => !Swal.isLoading(),
              }).then((result) => {
                console.log(result);
              });
            }
          });
        }}>
        <i className={value.row.original.ACTIVO ? "fs-5 bi bi-eye-slash btnIconoActive" : "fs-5 bi bi-eye btnIconoInactive"} />
      </button>
    );
  };

  const preconfirm = async (txtMotivo: string, idRegistro: number, activo: boolean, correlativo: string, idPlanificacion: number) => {
    if (!txtMotivo) {
      Swal.showValidationMessage(`Debe ingresar un motivo`);
    } else {
      await ProveedorService.desactivarRegistroMedida(token, {
        ID_REGISTRO: idRegistro,
        AUTOR: currentUser?.email as string,
        AUTOR_DISPLAY: currentUser?.fullname as string,
        CAMPO: "N/A",
        EDITOR: currentUser?.email as string,
        EDITOR_DISPLAY: currentUser?.fullname as string,
        MODULO: "PROVEEDORES-MEDIDAS",
        TABLA: "MEDIDA",
        MOTIVO: txtMotivo,
        VALOR_INICIAL: "N/A",
        DESACTIVAR: activo,
        FECHA_CREACION: new Date(),
        FECHA_MODIFICACION: new Date(),
        VALOR_FINAL: "N/A",
        ACCION: activo ? "DESACTIVAR" : "ACTIVAR",
        CORRELATIVO: correlativo,
      });
      console.log("idPlanificacion", idPlanificacion);
      await handleBuscarMM();
      ProveedorService.GenerarPDFPlanificacion(token, idPlanificacion);
    }
  };
  let columnsDef = [
    columnHelperMantMedidas.accessor((rowMM) => rowMM.TITULO, {
      id: "TITULO",
      cell: (infoMM: CellContext<IMedida, string>) => componentValue(infoMM.getValue()),
      header: () => component("Título"),
      hide: false,
      title: "Título",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `PF."TITULO"`,
    } as any),
    columnHelperMantMedidas.accessor((rowMM) => rowMM.ID, {
      id: "DESACTIVAR",
      cell: (infoMM: CellContext<IMedida, number>) => componentDesactivar(infoMM),
      header: () => component("Activar / Desactivar"),
      tipo: ITipo_Campo.text,
      className: "ps-3",
      disableSorting: true,
    } as any),
    columnHelperMantMedidas.accessor((rowMM) => rowMM.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<IMedida, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
      header: () => <span>Activo</span>,
      tipo: ITipo_Campo.check,
      title: "Activo",
    } as any),
    columnHelperMantMedidas.accessor((rowMM) => rowMM.TITULO_MEDIDA, {
      id: "TITULO_MEDIDA",
      cell: (infoMM: CellContext<IMedida, string>) => componentValue(infoMM.getValue()),
      header: () => component("Título Medida"),
      hide: false,
      title: "Título Medida",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"TITULO_MEDIDA"`,
    } as any),
    columnHelperMantMedidas.accessor((rowMM) => rowMM.MEDIDA, {
      id: "MEDIDA",
      cell: (infoMM: CellContext<IMedida, string>) => componentValue(infoMM.getValue()),
      header: () => component("Medida"),
      hide: false,
      title: "Medida",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `MD."MEDIDA"`,
    } as any),
    columnHelperMantMedidas.accessor((rowMM) => rowMM.ANIO, {
      id: "ANIO",
      cell: (infoMM: CellContext<IMedida, string>) => componentValue(infoMM.getValue()),
      header: () => component("Año"),
      hide: false,
      title: "Año",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `PL."ANIO"`,
    } as any),
    columnHelperMantMedidas.accessor((rowMM) => rowMM.AREA_RESPONSABLE, {
      id: "AREA_RESPONSABLE_COLUMNA",
      cell: (infoMM: CellContext<IMedida, string>) => componentValue(infoMM.getValue()),
      header: () => component("Área Responsable"),
      hide: false,
      title: "Área Responsable",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"AREA_RESPONSABLE"`,
    } as any),
    columnHelperMantMedidas.accessor((rowMM) => rowMM.TIPO_PROCESO, {
      id: "TIPO_PROCESO_COLUMNA",
      cell: (infoMM: CellContext<IMedida, string>) => componentValue(infoMM.getValue()),
      header: () => component("Tipo Proceso"),
      hide: false,
      title: "Tipo Proceso",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"TIPO_PROCESO"`,
    } as any),
    columnHelperMantMedidas.accessor((rowMM) => rowMM.PRODUCTO, {
      id: "PRODUCTO_COLUMNA",
      cell: (infoMM: CellContext<IMedida, string>) => componentValue(infoMM.getValue()),
      header: () => component("Producto"),
      hide: false,
      title: "Producto",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"PRODUCTO"`,
    } as any),
    columnHelperMantMedidas.accessor((rowMM) => rowMM.NOMBRE_PROVEEDOR, {
      id: "PROVEEDOR_COLUMNA",
      cell: (infoMM: CellContext<IMedida, string>) => componentValue(infoMM.getValue()),
      header: () => component("Proveedor"),
      hide: false,
      title: "Proveedor",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"NOMBRE_PROVEEDOR"`,
    } as any),
    columnHelperMantMedidas.accessor((rowMM) => rowMM.FECHA_CREACION, {
      id: "FECHA_CREACION",
      cell: (infoMM: CellContext<IMedida, string>) => componentValue(shortDate(infoMM.getValue())),
      header: () => component("Fecha Creación"),
      hide: false,
      title: "Fecha Creación",
      tipo: ITipo_Campo.date,
      className: "colorGris",
      sortId: `MD."FECHA_CREACION"`,
    } as any),
    columnHelperMantMedidas.accessor((rowMM) => shortDate(rowMM.FECHA_COMPROMISO), {
      id: "FECHA_COMPROMISO",
      cell: (infoMM: CellContext<IMedida, string>) => componentLink(infoMM.getValue()),
      header: () => component("Fecha Compromiso"),
      hide: false,
      title: "Fecha Compromiso",
      tipo: ITipo_Campo.date,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMM(cell);
        setIsEditColumMM(true);
        setIsSendingData(false);
      },
      sortId: `MD."FECHA_COMPROMISO"`,
    } as any),
    columnHelperMantMedidas.accessor((rowMM) => rowMM.RESPONSABLE_DISPLAY, {
      id: "RESPONSABLE",
      cell: (infoMM: CellContext<IMedida, string>) => componentLink(infoMM.getValue()),
      header: () => component("Responsable"),
      hide: false,
      title: "Responsable",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMM(cell);
        setIsEditColumMM(true);
        setIsSendingData(false);
      },
      sortId: `MD."RESPONSABLE_DISPLAY"`,
    } as any),
    columnHelperMantMedidas.accessor((rowMM) => rowMM.AUTOR_DISPLAY, {
      id: "AUTOR",
      cell: (infoMM: CellContext<IMedida, string>) => componentLink(infoMM.getValue()),
      header: () => component("Creado por"),
      hide: false,
      title: "Creado por",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMM(cell);
        setIsEditColumMM(true);
        setIsSendingData(false);
      },
      sortId: `MD."AUTOR_DISPLAY"`,
    } as any),
  ] as any;

  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    const comboVccMM = is_test
      ? cbVicePresidencia
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_AREA_RESPONSABLE}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboVccMM(comboVccMM);
  }, []);

  const getAllTipoProceso = async (e: any) => {
    let newParamsActive = { ...paramsActive, AREA_RESPONSABLE: e.value };
    const comboTPMM = is_test
      ? cbTipoProceso
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_PROCESO}/getall`, { Authorization: `Bearer ${token}` }, newParamsActive)).result.data;
    setComboTPMM(comboTPMM);
  };

  const getAllProductos = async (e: any) => {
    let newParamsActive = { ...paramsActive, TIPO_PROCESO: e.value };
    const comboPRDMM = is_test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_PRODUCTO}/getall`, { Authorization: `Bearer ${token}` }, newParamsActive)).result.data;
    setComboPRDMM(comboPRDMM);
  };
  const getAllProveedores = async (e: any) => {
    let newParamsActive = { ...paramsActive, PRODUCTO: e.value };
    const comboPRVMM = is_test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_PROVEEDOR}/getall`, { Authorization: `Bearer ${token}` }, newParamsActive)).result.data;
    setComboPRVMM(comboPRVMM);
  };

  const pagingMM = (page: any) => {
    setPage(page);
    filterMM({ PAGINA: page }, true);
  };

  const exportFileMM = () => {
    const valCorr = refTxtCorrMM.current?.value;
    const valVcc = refComboVccMM?.value;
    const valUP = refComboUPMM?.value;
    const valGSG = refComboGSGMM?.value;
    const valCSC = refComboCSCMM?.value;
    const valED = refComboEDMM?.value;
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      UNIDAD_PROYECTO: valUP,
      GERENCIA_SUBGERENCIA: valGSG,
      VICEPRESIDENCIA: valVcc,
      CONTRATISTA_SUBCONTRATISTA: valCSC,
      ESTADO: valED,
      CORRELATIVO: valCorr,
    };
    getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_MEDIDA}/ExportMantenedorMedida`, { Authorization: `Bearer ${token}` }, params).then((r) => {
      downloadFile(r.result);
    });
  };

  const filterMM = (filterMM: any, page: boolean = false, size = pageSize) => {
    setIsLoading(true);
    if (!filterMM) {
      filterMM = {};
    }

    filterMM.TIPO_FACTOR = filterMM.ID_TIPO_FACTOR?.toString() || "";
    filterMM.PAGINADO = size;
    if (filterMM.PAGINA === undefined) {
      filterMM.PAGINA = 1;
    }
    if (!page) {
      filterMM.PAGINA = 1;
    }
    setPage(filterMM.PAGINA);
    if (filterMM.ORDENADOPOR === undefined) {
      filterMM.ORDENADOPOR = `LIO."CORRELATIVO"`;
      filterMM.ORIENTACION = "DESC";
    }
    const valCorr = refTxtCorrMM.current?.value;
    const valVcc = refComboVccMM?.value;
    const valUP = refComboUPMM?.value;
    const valGSG = refComboGSGMM?.value;
    const valCSC = refComboCSCMM?.value;
    const valED = refComboEDMM?.value;
    filterMM.UNIDAD_PROYECTO = valUP;
    filterMM.GERENCIA_SUBGERENCIA = valGSG;
    filterMM.VICEPRESIDENCIA = valVcc;
    filterMM.CONTRATISTA_SUBCONTRATISTA = valCSC;
    filterMM.ESTADO = valED;
    filterMM.CORRELATIVO = valCorr;
    getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_MEDIDA}/GetAllMantenedorMedida`, { Authorization: `Bearer ${token}` }, filterMM)
      .then((result) => {
        setIsLoading(false);
        setListItemsMM(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };

  const editMM = (value: any, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";

    if (value.ID === "") {
      delete value.ID;
    }
  };

  const handleBuscarMM = async () => {
    setIsLoading(true);
    const valCorr = refTxtCorrMM.current?.value;
    const valVcc = refComboVccMM?.value === "Seleccione" ? "" : refComboVccMM?.value;
    const valUP = refComboUPMM?.value === "Seleccione" ? "" : refComboUPMM?.value;
    const valGSG = refComboGSGMM?.value === "Seleccione" ? "" : refComboGSGMM?.value;
    const valED = refComboEDMM?.value === "Seleccione" ? "" : refComboEDMM?.value;
    const valCSC = refComboCSCMM?.value === "Seleccione" ? "" : refComboCSCMM?.value;
    const valprv = refcomboPRVMM?.value === "Seleccione" ? "" : refcomboPRVMM?.label;
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      UNIDAD_PROYECTO: valUP,
      GERENCIA_SUBGERENCIA: valGSG,
      VICEPRESIDENCIA: valVcc,
      CONTRATISTA_SUBCONTRATISTA: valCSC,
      ESTADO: valED,
      ANIO: valCorr,
      NOMBRE_PROVEEDOR: valprv,
    };

    const result = is_test
      ? { data: [], pages: 10 }
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_MEDIDA}/GetAllMantenedorMedida`, { Authorization: `Bearer ${token}` }, params)).result;
    setArrCambiosFormMM([]);
    let list = result.data;
    setListItemsMM(list);
    let pages = result.pages;
    setPages(pages);
    setHideTable(false);
    setIsLoading(false);
  };

  const confirmed = () => {
    let arrMedidas: Array<IMedida> = [];

    let arrPrvMed: Array<IMedida> = [];
    let arrLogs: Array<ILogMantenedor> = [];

    arrCambiosFormMM.forEach((ac) => {
      if (!arrPrvMed.find((d) => d.ID === ac.ID)) {
        arrPrvMed.push(ac.OBJETO_REF);
      }
    });

    arrCambiosFormMM.forEach((ac) => {
      if (!arrMedidas.find((d) => d.ID === ac.ID)) {
        arrMedidas.push(ac.OBJETO_REF);
      }
    });

    arrMedidas.forEach((d: any) => {
      arrCambiosFormMM
        .filter((ac) => ac.ID === d.ID)
        .forEach((ac) => {
          let log: ILogMantenedor = {
            ID: null,
            MODULO: "PROVEEDORES-MEDIDAS",
            TABLA: "MEDIDA",
            ID_REGISTRO: d.ID,
            CAMPO: ac.CAMPO_EDITADO_ID,
            VALOR_INICIAL: ac.VALOR_ORIGINAL,
            VALOR_FINAL: null,
            MOTIVO: refTxtMotivoMM.current?.value || "",
            AUTOR: currentUser?.email || "",
            FECHA_CREACION: new Date(),
            EDITOR: "",
            FECHA_MODIFICACION: new Date(),
            AUTOR_DISPLAY: currentUser?.fullname || "",
            EDITOR_DISPLAY: "",
            CORRELATIVO: d.TITULO,
          };

          if (ac.TIPO === ITipo_Campo.user) {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID];
            d[ac.CAMPO_EDITADO_ID + "_DISPLAY"] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
            log.VALOR_FINAL = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
          } else if (ac.TIPO === ITipo_Campo.date) {
            d[ac.CAMPO_EDITADO_ID] = moment(moment(ac.VALOR_NUEVO).format(moment.HTML5_FMT.DATE)).toDate();
            log.VALOR_FINAL = ac.VALOR_NUEVO;
          } else {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO;
            log.VALOR_FINAL = ac.VALOR_NUEVO;
          }
          arrLogs.push(log);
        });
    });

    let value = {
      LOG_MANTENEDOR: arrLogs,
      MEDIDA: arrMedidas,
    };

    postAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_MEDIDA}/MantenedorMedida`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        let params = { PAGINA: page };
        filterMM(params);
      })
      .catch((error) => {
        console.log(error);
      });
    if (refTxtMotivoMM.current) {
      refTxtMotivoMM.current.value = "";
    }
    setArrCambiosFormMM([]);
    setIsOpenPopUpGuardarCambiosMM(false);
    setShowToastMM(true);
  };

  return (
    <section>
      <div className="row">
        <button
          data-testid="btnedit"
          hidden={true}
          onClick={() => {
            editMM({ ID: "" }, {});
            filterMM({});
            exportFileMM();
            pagingMM(1);
            handleBuscarMM();
            confirmed();
            preconfirm("", 1, true, "", 1);
            preconfirm("2", 1, true, "", 1);
            getAllTipoProceso("");
            getAllProductos("");
            getAllProveedores("");
          }}></button>
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-2">
              <h1 className="titPrincipal colorTit mt-2">Mantenedor Proveedores - Medidas</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Importante:</strong> Este módulo es de uso exclusivo de administración y su uso esta bajo su responsabilidad
                </small>
              </div>
              <div className="row mb-1 ajusteInput">
                <div className="col-6">
                  <Col>
                    <label>Año:</label>
                  </Col>
                  <Col>
                    <input type="text" ref={refTxtCorrMM} className="form-control form-control-sm" />
                  </Col>
                </div>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Área Responsable:</label>
                  <Select
                    options={comboVccMM.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO })) as any}
                    placeholder="Seleccione"
                    value={refComboVccMM || ""}
                    isClearable={true}
                    onChange={async (e: any) => {
                      setValComboVccMM(e);
                      getAllTipoProceso(e);
                      setValComboTPMM(null);
                      setValComboPRVMM(null);
                      setValComboPRVMM(null);
                      setComboTPMM([]);
                      setComboPRDMM([]);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Tipo Proceso:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refcomboTPMM || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboTPMM.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboTPMM(e);
                      getAllProductos(e);
                      setValComboPRVMM(null);
                      setValComboPRVMM(null);
                      setComboPRDMM([]);
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Producto:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboPRDMM || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboPRDMM.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboPRDMM(e);
                      getAllProveedores(e);
                      setValComboPRVMM(null);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Proveedor:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refcomboPRVMM || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboPRVMM.map((vcc) => ({ value: vcc.ID as string, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboPRVMM(e);
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 mt-2">
                <Col xs="12" md="12" lg="12">
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => {
                      handleBuscarMM();
                    }}>
                    {" "}
                    <i className="bi bi-search"></i> Buscar
                  </button>
                  <button
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => {
                      (refTxtCorrMM.current as HTMLInputElement).value = "";
                      setValComboVccMM(null);
                      setValComboUPMM(null);
                      setValComboGSGMM(null);
                      setValComboCSCMM(null);
                      setValComboEDMM(null);
                      setValComboTPMM(null);
                      setValComboPRDMM(null);
                      setValComboPRVMM(null);
                      setListItemsMM([]);
                    }}>
                    {" "}
                    <i className="bi bi-stars"></i> Limpiar Campos
                  </button>

                  {arrCambiosFormMM.length > 0 && (
                    <button
                      className="btn btn-primary btn-sm me-2 float-end"
                      onClick={() => {
                        setIsOpenPopUpGuardarCambiosMM(true);
                      }}>
                      {" "}
                      <i className="bi bi-check"></i> Guardar Cambios
                    </button>
                  )}
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-1">
        <AdminLista
          reload={filterMM}
          items={[]}
          callback={editMM}
          data={listItemsMM}
          tipo={"MantenedorMedidas"}
          filter={filterMM}
          pagination={{ pages: pages, page: page, paging: pagingMM }}
          title=""
          hideAdd={true}
          hideExport={true}
          exportar={exportFileMM}
          columnsDef={columnsDef}
          hideTable={hideTable}
          callbackUpdatePageSize={(pageSize: number, filters: Object) => {
            setPageSize(pageSize);
            filterMM(filters, false, pageSize);
          }}
          isLoading={isLoading}
        />
      </div>

      {editColumnInfo && (
        <Offcanvas
          show={isEditColum}
          onHide={() => {
            setIsEditColumMM(false);
          }}
          placement={"end"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Editar - {editColumnInfo.column.columnDef.title}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <div className="ajusteInput">
                <label>Valor Original</label>
              </div>
              <div>
                {editColumnInfo &&
                  (editColumnInfo.getValue()?.TIPO === ITipo_Campo.date ? shortDate(editColumnInfo.getValue()) : editColumnInfo.getValue())}
              </div>
            </div>
            <div className="row mb-2 ajusteInput">
              <div>
                <label>Nuevo Valor</label>
                <form className="form-control-sm">
                  {
                    <RenderForm
                      id={editColumnInfo?.column?.id}
                      tipoCampo={editColumnInfo?.column.columnDef.tipo}
                      valor={""}
                      texto={""}
                      callback={changeField}
                    />
                  }
                </form>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    let json = selectedField;
                    let arr = arrCambiosFormMM;
                    json = {
                      ID: editColumnInfo.row.original.ID,
                      CAMPO_EDITADO: editColumnInfo.column.columnDef.title,
                      CAMPO_EDITADO_ID: editColumnInfo.column.columnDef.id,
                      VALOR_ORIGINAL: editColumnInfo?.getValue(),
                      VALOR_NUEVO:
                        editColumnInfo.column.columnDef.tipo === ITipo_Campo.user ? selectedField : selectedField[editColumnInfo.column.columnDef.id],
                      OBJETO_REF: editColumnInfo.row.original,
                      TIPO: editColumnInfo.column.columnDef.tipo,
                    };
                    if (
                      !isSendingData &&
                      json.VALOR_ORIGINAL !==
                        (editColumnInfo.column.columnDef.tipo === ITipo_Campo.user
                          ? json.VALOR_NUEVO[json.VALOR_NUEVO.ID + "_DISPLAY"]
                          : json.VALOR_NUEVO)
                    ) {
                      arr.push(json);
                      setArrCambiosFormMM(arr);
                      setIsEditColumMM(false);
                      setIsSendingData(true);
                    }
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>

                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsEditColumMM(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      {isOpenPopUpGuardarCambiosMM && (
        <Offcanvas
          show={isOpenPopUpGuardarCambiosMM}
          onHide={() => {
            setIsOpenPopUpGuardarCambiosMM(false);
          }}
          placement={"end"}
          className={"w-50"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Confirmar Cambios</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <span>Se realizarán los siguientes cambios en los siguientes registros de Medidas:</span>
            </div>
            <div className="row mb-2">
              <AdminLista
                reload={filterMM}
                items={[]}
                callback={editMM}
                data={arrCambiosFormMM}
                tipo={"MantenedorMedidas"}
                filter={filterMM}
                pagination={{ pages: pages, page: page, paging: pagingMM }}
                title=""
                hideAdd={true}
                hideExport={true}
                hideReload={true}
                hidePagination={true}
                exportar={exportFileMM}
                columnsDef={[
                  columnHelperConfirmacionCambios.accessor((rowMM) => rowMM.ID, {
                    id: "ID",
                    cell: (infoMM: CellContext<IConfirmacionMantenedor, string>) => componentValue(infoMM.getValue()),
                    header: () => component("ID Registro"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMM) => rowMM.CAMPO_EDITADO, {
                    id: "CAMPO_EDITADO",
                    cell: (infoMM: CellContext<IConfirmacionMantenedor, string>) => componentValue(infoMM.getValue()),
                    header: () => component("Campo Editado"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMM) => rowMM.VALOR_ORIGINAL, {
                    id: "VALOR_ORIGINAL",
                    cell: (infoMM: CellContext<IConfirmacionMantenedor, string>) => componentValue(infoMM.getValue()),
                    header: () => component("Valor Original"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMM) => rowMM.VALOR_NUEVO, {
                    id: "VALOR_NUEVO",
                    cell: (infoMM: CellContext<IConfirmacionMantenedor, any>) => componentValue(infoMM.getValue(), infoMM.getValue()?.TIPO),
                    header: () => component("Nuevo Valor"),
                    tipo: ITipo_Campo.text,
                  } as any),
                ]}
              />
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <label>Motivos Modificación</label>
              </div>
              <div className="col-12">
                <textarea ref={refTxtMotivoMM} className="w-100"></textarea>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    if (!refTxtMotivoMM.current?.value) {
                      refTxtMotivoMM.current?.classList.add("error");
                      return;
                    } else {
                      refTxtMotivoMM.current?.classList.remove("error");
                    }

                    MySwal.fire({
                      html: (
                        <div>
                          <h3>¿Desea realizar los cambios con el siguiente Motivo descrito?</h3>
                          <div>(se registraran las modificaciones a su nombre y cada una asociada al motivo entregado)</div>
                        </div>
                      ),
                      text: refTxtMotivoMM.current?.value,
                      icon: "question",
                      confirmButtonText: "Aceptar",
                      cancelButtonText: "Cancelar",
                      showCloseButton: true,
                      showCancelButton: true,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        confirmed();
                      }
                    });
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>
                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsOpenPopUpGuardarCambiosMM(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      <div className="row">
        <div className="col-12">
          <CustomToast show={showToast} title="Administración" />
        </div>
      </div>
    </section>
  );
}
